<div class="bg-m0 relative flex h-full w-full flex-col rounded shadow">
  <div class="mb-6 mt-6 flex h-11 flex-shrink-0 flex-row items-center">
    <m-search-icon class="text-s1 ml-8"></m-search-icon>

    <input
      spellcheck="false"
      autocomplete="off"
      class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[225px] select-none rounded"
      placeholder="Search"
      [ngClass]="{
        'bg-p200': !!searchWord
      }"
      [(ngModel)]="searchWord"
      (ngModelChange)="searchWordChange()"
    />

    <div class="ml-3 h-9 w-9 flex-shrink-0" *ngIf="!!searchWord">
      <m-delete-icon
        class="text-s1 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
        [ngClass]="{
          'bg-p200 hover:bg-p300 cursor-pointer': !!searchWord
        }"
        (click)="resetSearch()"
      ></m-delete-icon>
    </div>

    <div
      class="ml-5 flex h-9 w-9 flex-shrink-0 items-center justify-center"
      [tp]="
        showQuestionMarks ? 'Show Descriptions: ON' : 'Show Descriptions: OFF'
      "
      tpPlacement="top"
    >
      <button
        type="button"
        class="flex h-9 w-9 cursor-pointer items-center justify-center focus:outline-none"
        [ngClass]="{
          'text-green-600': showQuestionMarks,
          'text-s500': !showQuestionMarks
        }"
        (click)="toggleQuestionMarks()"
      >
        <m-question-mark-circle-icon
          class="scale-125"
        ></m-question-mark-circle-icon>
      </button>
    </div>

    <div
      class="ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center"
      [tp]="showIndexes ? 'Swos Indexes: ON' : 'Show Indexes: OFF'"
      tpPlacement="top"
    >
      <button
        type="button"
        class="flex h-7 w-7 cursor-pointer items-center justify-center focus:outline-none"
        [ngClass]="{
          'text-green-600': showIndexes,
          'text-s500': !showIndexes
        }"
        (click)="toggleIndexes()"
      >
        <m-database-zap-icon></m-database-zap-icon>
      </button>
    </div>

    <button
      tp="Refresh schemas"
      type="button"
      class="hover:bg-m200 ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
      (click)="loadSchemas({ isRefreshExistingCache: true })"
    >
      <m-refresh-icon></m-refresh-icon>
    </button>

    <div class="relative ml-5 flex h-7 w-7 flex-shrink-0">
      <ngx-spinner
        *ngIf="isRefreshing"
        [name]="spinnerName"
        color="#0084d1"
        bdColor="#00000000"
        size="default"
        type="ball-clip-rotate"
        [fullScreen]="false"
        [disableAnimation]="true"
        [zIndex]="10"
      >
      </ngx-spinner>
    </div>

    <div class="flex flex-1"></div>

    <!-- <button
      *ngIf="schemasLoaded && treeNodes.length > 0"
      tp="Graph"
      tpPlacement="top"
      type="button"
      class="hover:bg-m200 text-s500 mr-10 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
      (click)="graphAllOnClick()"
    >
      <m-network-icon></m-network-icon>
    </button> -->
  </div>

  <div class="divide-s300 ml-6 mr-6 flex flex-col divide-y">
    <div class="flex flex-row"></div>
    <div class="flex flex-row"></div>
  </div>

  <div
    *ngIf="schemasLoaded && treeNodes.length === 0"
    class="pointer-events-none absolute inset-0 flex select-none items-center justify-center text-xl"
  >
    No SQL Schemas Found
  </div>

  <div
    *ngIf="filteredTreeNodes.length > 0"
    class="flex h-2 w-full flex-grow flex-col overflow-y-auto"
  >
    <ng-scrollbar
      [orientation]="'vertical'"
      [visibility]="'hover'"
      [appearance]="'compact'"
    >
      <div class="mt-2 h-full w-full pb-6 pl-6 pr-6">
        <tree-root
          #itemsTree
          [nodes]="filteredTreeNodes"
          [options]="treeOptions"
        >
          <ng-template #treeNodeTemplate let-node="node">
            <div
              class="group flex h-11 w-full select-none flex-row items-center rounded pr-5"
              [ngClass]="{
                'cursor-pointer': node.hasChildren,
                'hover:bg-m50': true
              }"
              [style.padding-left.px]="(node.level - 1) * 12"
              (click)="nodeOnClick({ node: node })"
            >
              <div class="flex flex-row items-center pl-4">
                <div *ngIf="node.hasChildren" class="flex items-center">
                  <m-chevron-right-icon
                    class="text-s500"
                    *ngIf="!node.isExpanded"
                  ></m-chevron-right-icon>

                  <m-chevron-down-icon
                    class="text-s500"
                    *ngIf="node.isExpanded"
                  ></m-chevron-down-icon>
                </div>

                <div *ngIf="!node.hasChildren" class="w-[24px]"></div>
              </div>

              <div
                *ngIf="node.data.nodeType !== 'column'"
                class="ml-2 flex min-w-0 flex-1 items-center"
                [ngClass]="{
                  'text-[17px]':
                    node.data.nodeType === 'connection' ||
                    node.data.nodeType === 'error',
                  'text-[16px]':
                    node.data.nodeType !== 'connection' &&
                    node.data.nodeType !== 'error',
                  'text-s1': node.data.nodeType !== 'error',
                  'text-red-600': node.data.nodeType === 'error'
                }"
                [tp]="node.data.errorMessage"
                tpPlacement="top"
              >
                <span class="truncate">{{ node.data.name }}</span>
                <span
                  *ngIf="
                    node.data.tableType &&
                    node.data.tableType !== 'BASE TABLE' &&
                    node.data.tableType !== 'MANAGED'
                  "
                  class="text-s400 ml-3 flex-shrink-0 uppercase"
                  >[{{ node.data.tableType }}]</span
                >

                <button
                  *ngIf="showQuestionMarks && node.data.description"
                  type="button"
                  [tp]="node.data.description"
                  class="text-s500 ml-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="$event.stopPropagation()"
                >
                  <m-question-mark-circle-icon></m-question-mark-circle-icon>
                </button>
              </div>

              <button
                *ngIf="
                  (node.data.nodeType === 'connection' ||
                    node.data.nodeType === 'table') &&
                  node.data.hasUncachedCacheUniqueValuesRecommendation === true
                "
                type="button"
                tp="Has columns recommended to cache unique values, but cache is empty"
                tpPlacement="top"
                class="text-a500 ml-2 mr-1 mt-1 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                (click)="$event.stopPropagation()"
              >
                <m-exclamation-icon></m-exclamation-icon>
              </button>

              <!-- <button
                *ngIf="node.data.nodeType === 'connection'"
                type="button"
                tp="Copy schema name"
                tpPlacement="top"
                class="hover:bg-m200 hover:text-s1 text-s500 invisible ml-auto flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
                (click)="
                  copyToClipboard({
                    text: node.data.schemaDisplayName,
                    event: $event
                  })
                "
              >
                <m-copy-icon></m-copy-icon>
              </button> -->

              <button
                *ngIf="node.data.nodeType === 'connection'"
                type="button"
                tp="Graph"
                tpPlacement="top"
                class="hover:bg-m200 hover:text-s1 text-s500 ml-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                (click)="graphOnClick({ node: node, event: $event })"
              >
                <m-network-icon></m-network-icon>
              </button>

              <!-- <button
                *ngIf="node.data.nodeType === 'table'"
                type="button"
                tp="Copy table name"
                tpPlacement="top"
                class="hover:bg-m200 hover:text-s1 text-s500 invisible ml-auto flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
                (click)="
                  copyToClipboard({
                    text: node.data.tableName,
                    event: $event
                  })
                "
              >
                <m-copy-icon></m-copy-icon>
              </button> -->

              <button
                *ngIf="node.data.nodeType === 'table'"
                type="button"
                tp="Sample"
                tpPlacement="top"
                class="text-s500 ml-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                [ngClass]="{
                  'hover:bg-m200 hover:text-s1':
                    sampleSpinnerNodeId !== node.data.id,
                  'invisible group-hover:visible':
                    sampleSpinnerNodeId !== node.data.id
                }"
                (click)="sampleOnClick({ node: node, event: $event })"
              >
                <div
                  *ngIf="sampleSpinnerNodeId === node.data.id"
                  class="border-s200 border-t-m600 h-6 w-6 flex-shrink-0 animate-spin rounded-full border-2 [animation-duration:750ms]"
                >
                </div>
                <m-table-icon
                  *ngIf="sampleSpinnerNodeId !== node.data.id"
                ></m-table-icon>
              </button>

              <div
                *ngIf="node.data.nodeType === 'column'"
                class="ml-2 flex min-w-0 flex-1 items-center truncate text-[16px]"
              >
                <button
                  *ngIf="node.data.references?.length > 0"
                  class="hover:bg-m200 text-s1 mr-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  [tp]="fkTemplate"
                  [tpHideOnEscape]="true"
                  tpVariation="menu"
                  className="my-menu"
                  (click)="$event.stopPropagation()"
                >
                  <m-link-icon></m-link-icon>
                </button>

                <span class="text-s1 font-semibold">{{
                  node.data.columnName
                }}</span>

                <ng-template #fkTemplate>
                  <div
                    class="border-s4 bg-m0 w-max max-w-[800px] rounded-md border-2 shadow-xl"
                  >
                    <div
                      *ngFor="let ref of node.data.references"
                      class="text-s1 w-full px-4 py-2 text-left text-base"
                    >
                      <span *ngIf="ref.isForeignKey" class="text-blue-400"
                        >FK</span
                      ><span
                        *ngIf="ref.isForeignKey && ref.relationshipType"
                        class="ml-3"
                      >
                      </span
                      ><span
                        *ngIf="ref.relationshipType"
                        class="text-orange-500"
                        >{{ ref.relationshipType }}</span
                      ><span *ngIf="ref.relationshipType" class="ml-3"> </span
                      ><span
                        *ngIf="!ref.relationshipType && ref.isForeignKey"
                        class="ml-3"
                      >
                      </span
                      ><span *ngIf="ref.referencedSchemaName"
                        >{{ ref.referencedSchemaName }}.</span
                      >{{ ref.referencedTableName }}.<span
                        class="font-semibold"
                        >{{ ref.referencedColumnName }}</span
                      >
                    </div>
                  </div>
                </ng-template>

                <span
                  *ngIf="node.data.isNullable === false"
                  class="text-s400 ml-3"
                  >not null</span
                >

                <span class="text-s400 ml-3 uppercase">{{
                  node.data.dataType
                }}</span>

                <span *ngIf="node.data.isPrimaryKey" class="text-s400 ml-3"
                  >[PRIMARY]</span
                >
                <span
                  *ngIf="node.data.isUnique && !node.data.isPrimaryKey"
                  class="text-s400 ml-3"
                  >[UNIQUE]</span
                >

                <button
                  *ngIf="
                    showQuestionMarks &&
                    (node.data.description || node.data.example)
                  "
                  type="button"
                  [tp]="
                    node.data.description && node.data.example
                      ? node.data.description +
                        ' | Example: ' +
                        node.data.example
                      : node.data.example
                        ? 'Example: ' + node.data.example
                        : node.data.description
                  "
                  class="text-s500 ml-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="$event.stopPropagation()"
                >
                  <m-question-mark-circle-icon></m-question-mark-circle-icon>
                </button>
              </div>

              <!-- <button
                *ngIf="node.data.nodeType === 'column'"
                type="button"
                tp="Copy column name"
                tpPlacement="top"
                class="hover:bg-m200 hover:text-s1 text-s500 invisible ml-auto flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
                (click)="
                  copyToClipboard({
                    text: node.data.columnName,
                    event: $event
                  })
                "
              >
                <m-copy-icon></m-copy-icon>
              </button> -->

              <div
                *ngIf="node.data.nodeType === 'column'"
                class="ml-2 flex flex-shrink-0 items-center"
                [tp]="templateCachedColumnTooltip"
                tpPlacement="top"
              >
                <div
                  *ngIf="isCachedColumnSpinning({ nodeId: node.data.id })"
                  class="border-s200 border-t-m600 mr-2 h-5 w-5 flex-shrink-0 animate-spin rounded-full border-2 [animation-duration:750ms]"
                >
                </div>

                <button
                  type="button"
                  class="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  [ngClass]="{
                    'text-blue-500':
                      node.data.cachedColumn?.status === 'completed',
                    'text-red-600': node.data.cachedColumn?.status === 'error',
                    'text-a500':
                      node.data.cacheUniqueValues === true &&
                      !node.data.cachedColumn,
                    'text-s500':
                      node.data.cachedColumn?.status !== 'completed' &&
                      node.data.cachedColumn?.status !== 'error' &&
                      !(
                        node.data.cacheUniqueValues === true &&
                        !node.data.cachedColumn
                      ),
                    'hover:bg-m200': !isCachedColumnSpinning({
                      nodeId: node.data.id
                    }),
                    'hover:text-s1':
                      node.data.cachedColumn?.status !== 'completed' &&
                      node.data.cachedColumn?.status !== 'error' &&
                      !(
                        node.data.cacheUniqueValues === true &&
                        !node.data.cachedColumn
                      ) &&
                      !isCachedColumnSpinning({
                        nodeId: node.data.id
                      })
                  }"
                  [tp]="templateCachedColumnMenu"
                  [tpHideOnEscape]="true"
                  tpVariation="menu"
                  className="my-menu"
                  #cachedColumnTpRef="tippy"
                  (click)="$event.stopPropagation()"
                >
                  <m-database-icon></m-database-icon>
                </button>

                <ng-template #templateCachedColumnInfo>
                  <div
                    *ngIf="!node.data.cachedColumn"
                    class="whitespace-nowrap"
                  >
                    Unique values cache is empty
                  </div>

                  <div
                    *ngIf="node.data.cachedColumn?.status === 'running'"
                    class="whitespace-nowrap"
                  >
                    Cache refresh is running
                  </div>

                  <div
                    *ngIf="
                      node.data.cachedColumn != null &&
                      node.data.cachedColumn?.status !== 'running'
                    "
                    class="grid grid-cols-[auto_auto] gap-x-3 gap-y-1 whitespace-nowrap"
                  >
                    <div>Unique values</div>
                    <div class="text-right font-semibold">
                      {{
                        formatNumber({
                          value: node.data.cachedColumn.uniqueValuesCount ?? 0
                        })
                      }}
                    </div>
                    <div *ngIf="node.data.cachedColumn.sampleSize != null">
                      Sample size
                    </div>
                    <div
                      *ngIf="node.data.cachedColumn.sampleSize != null"
                      class="text-right font-semibold"
                    >
                      {{
                        formatNumber({
                          value: node.data.cachedColumn.sampleSize
                        })
                      }}
                    </div>
                    <div>Cached</div>
                    <div class="text-right font-semibold">
                      {{
                        formatDate({ ts: node.data.cachedColumn.completedTs })
                      }}
                    </div>
                    <div>Duration</div>
                    <div class="text-right font-semibold">
                      {{
                        formatDuration({
                          completedDurationMs:
                            node.data.cachedColumn.completedDurationMs
                        })
                      }}
                    </div>
                  </div>
                </ng-template>

                <ng-template #templateCachedColumnTooltip>
                  <ng-container
                    *ngIf="
                      node.data.cacheUniqueValues === true &&
                        !node.data.cachedColumn;
                      else templateCachedColumnDefaultTooltip
                    "
                  >
                    Recommended to cache unique values
                  </ng-container>
                  <ng-template #templateCachedColumnDefaultTooltip>
                    Cache
                  </ng-template>
                </ng-template>

                <ng-template #templateCachedColumnMenu>
                  <div
                    class="border-s4 bg-m0 w-72 rounded-md border-2 shadow-xl"
                  >
                    <button
                      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                      [ngClass]="{
                        'text-s400 cursor-default': !node.data.cachedColumn
                      }"
                      [disabled]="!node.data.cachedColumn"
                      (click)="
                        cachedColumnTpRef.hide();
                        viewCachedColumn({
                          node: node,
                          event: $event
                        })
                      "
                      >View cached unique values</button
                    >
                    <button
                      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                      [ngClass]="{
                        'text-s400 cursor-default': isCachedColumnSpinning({
                          nodeId: node.data.id
                        })
                      }"
                      [disabled]="
                        isCachedColumnSpinning({ nodeId: node.data.id })
                      "
                      (click)="
                        cachedColumnTpRef.hide();
                        refreshCachedColumn({
                          node: node,
                          event: $event,
                          refreshType: 'full'
                        })
                      "
                      >Refresh cache</button
                    >
                    <button
                      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                      [ngClass]="{
                        'text-s400 cursor-default': isCachedColumnSpinning({
                          nodeId: node.data.id
                        })
                      }"
                      [disabled]="
                        isCachedColumnSpinning({ nodeId: node.data.id })
                      "
                      (click)="
                        cachedColumnTpRef.hide();
                        refreshCachedColumnSample({
                          node: node,
                          event: $event
                        })
                      "
                      >Refresh cache by sample</button
                    >
                    <button
                      class="text-s1 hover:bg-m50 w-full px-4 py-2 text-left text-base focus:outline-none"
                      (click)="
                        cachedColumnTpRef.hide();
                        clearCachedColumn({
                          node: node,
                          event: $event
                        })
                      "
                      >Clear cache</button
                    >
                    <div
                      class="border-s4 text-s500 mt-2 select-none border-t px-4 py-2 text-base"
                    >
                      <ng-container
                        *ngTemplateOutlet="templateCachedColumnInfo"
                      ></ng-container>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </ng-template>
        </tree-root>
      </div>
    </ng-scrollbar>
  </div>

  <div *ngIf="nav$ | async"></div>
</div>
